import React from 'react';
import Utils from './Utils.js';
import Player from './Player.js';

class Players extends React.Component
{
	render()
	{
		return (
			<div className="playerList">
				<div className="subtitle">Liste des joueurs :</div>
				<div>
					{Utils.range(1,this.props.nbPlayers).map(playerNum => 
						<Player key={"playerkey"+playerNum} numPlayer={playerNum} playerName={this.props.playerNames[playerNum-1]} onPlayerNameChange={this.props.onPlayerNameChange} playerList={this.props.playerList}/>
					)}
				</div>
				
			</div>
		);
	}
}

export default Players;
